import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { mediaUrl } from "../lib/api";

export default function Gallery({ images = [] }) {
    const [open, setOpen] = useState(-1);

    useEffect(() => {
        if (open < 0) return;
        const onKey = (e) => {
            if (e.key === "Escape") setOpen(-1);
            if (e.key === "ArrowRight") setOpen((i) => (i + 1) % images.length);
            if (e.key === "ArrowLeft") setOpen((i) => (i - 1 + images.length) % images.length);
        };
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKey);
        };
    }, [open, images.length]);

    if (!images.length) return null;

    return (
        <>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-testid="gallery-grid">
                {images.map((src, i) => (
                    <button
                        key={i}
                        onClick={() => setOpen(i)}
                        data-testid={`gallery-item-${i}`}
                        className="editorial-card group aspect-[4/5] overflow-hidden bg-neutral-900"
                    >
                        <div className="img-wrap w-full h-full">
                            <img
                                src={mediaUrl(src)}
                                alt={`gallery ${i + 1}`}
                                loading="lazy"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </button>
                ))}
            </div>

            {open >= 0 && (
                <div
                    className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
                    onClick={() => setOpen(-1)}
                    data-testid="gallery-lightbox"
                >
                    <button
                        className="absolute top-6 right-6 text-white p-2"
                        onClick={() => setOpen(-1)}
                        data-testid="gallery-close"
                    >
                        <X size={28} />
                    </button>
                    <button
                        className="absolute left-4 md:left-10 text-white p-3"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen((i) => (i - 1 + images.length) % images.length);
                        }}
                        data-testid="gallery-prev"
                    >
                        <ChevronLeft size={34} />
                    </button>
                    <img
                        src={mediaUrl(images[open])}
                        alt="preview"
                        className="max-w-[92vw] max-h-[86vh] object-contain"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button
                        className="absolute right-4 md:right-10 text-white p-3"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen((i) => (i + 1) % images.length);
                        }}
                        data-testid="gallery-next"
                    >
                        <ChevronRight size={34} />
                    </button>
                </div>
            )}
        </>
    );
}
